const moment = require('moment');
const { PRODUCT } = require('./types');
const getSimpleDateFR = date => {
    if(!date) return date;
    if(typeof date == 'string' && date.includes('/')) {
        return date;
    } 
    return moment(date).format('DD/MM/YYYY');
}
const getSimpleDateTimeFR = date => {
    if(!date) return date;
    if(typeof date == 'string' && date.includes('/')) {
        return date;
    } 
    return moment(date).format('DD/MM/YYYY HH:mm');
}

const toCurrency = val => new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(val||0);

const isMH = product => (product === PRODUCT.MH || product === PRODUCT.MH_TEMPO);

const isTablette = size => size === 'medium';
const isPhone = size => {
    console.log('size: ', size);
    return size === 'small' || size === 'xsmall' || size === 'xxsmall';
}
const isSmallDevis = size => isTablette(size) || isPhone(size);

const toArrayOfArray = (original, length = 3) => {
    if (!original || original.length === 0) return original;
    let result = [];
    let group = [];
    for (let i = 0; i < original.length; i++) {
        if (i > 0 && i % length === 0) {
            result.push(group);
            group = [];
        }
        group.push(original[i]);
    }
    result.push(group);
    return result;
};
module.exports = {
    getSimpleDateFR,
    getSimpleDateTimeFR,
    toCurrency,
    isMH,
    isPhone,
    isTablette,
    isSmallDevis,
    toArrayOfArray,
}